'use client'
// Helper function to detect chunk loading errors
export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false

  const errorString = error.toString().toLowerCase()
  const errorMessage = ((error as Error).message || '').toLowerCase()
  const errorName = ((error as Error).name || '').toLowerCase()

  // Common patterns for chunk loading errors
  const chunkErrorPatterns = [
    'loading chunk',
    'chunk load failed',
    'failed to load chunk',
    'loading css chunk',
    'loading css file',
    'chunkloaderror',
    'chunk not loaded',
    'loading dynamic import',
    'failed to fetch',
    'networkerror',
    'fetch error',
    // Next.js specific patterns
    '_next/static',
    'dynamic import',
    // Webpack specific
    'webpack',
  ]

  // Check if the error matches any chunk loading patterns
  const isChunkError = chunkErrorPatterns.some(pattern => (
    errorString.includes(pattern)
    || errorMessage.includes(pattern)
    || errorName.includes(pattern)
  ))

  // Additional checks for network-related errors that could be chunk loading
  const isNetworkError = (
    (error as Error).name === 'TypeError'
    && (errorMessage.includes('fetch') || errorMessage.includes('network'))
  ) || (
    (error as Error).name === 'ChunkLoadError'
  )

  return isChunkError || isNetworkError
}
